module.exports = __webpack_public_path__ + "91687e197166a87cfb24400a112a2620.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/fi-1997.png
// module id = 515
// module chunks = 0